var map = {
	"./template.betgalaxy": 2054,
	"./template.betgalaxy.tsx": 2054,
	"./template.betprofessor": 1855,
	"./template.betprofessor.tsx": 1855,
	"./template.betroyale": 1856,
	"./template.betroyale.tsx": 1856,
	"./template.default": 706,
	"./template.default.tsx": 706,
	"./template.fiestabet": 1857,
	"./template.fiestabet.tsx": 1857,
	"./template.puntcity": 1858,
	"./template.puntcity.tsx": 1858,
	"./template.puntgenie": 1859,
	"./template.puntgenie.tsx": 1859,
	"./template.questbet": 1860,
	"./template.questbet.tsx": 1860,
	"./template.ts": 995,
	"./template.volcanobet": 1861,
	"./template.volcanobet.tsx": 1861,
	"./template.wellbet": 1862,
	"./template.wellbet.tsx": 1862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2784;